import http from '../../../utils/http';

class StatisticsApi {
  async getStatistics() {
    return http.get('/fraudcases/statistics');
  }
}

export default StatisticsApi;
